import { useCallback, useContext } from "react";
import SandBoxContext from "../../../../SandBoxContext";

export const useClearSchema = () => {
  const dispatch = useContext(SandBoxContext)[1];

  return useCallback(() => dispatch({ type: "RESET_SCHEMA" }), [dispatch]);
};
